var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartControlZoomOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Interactive-States",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0 C4.4771525,0 0,4.4771525 0,10 C0,15.5228475 4.4771525,20 10,20 C15.5228475,20 20,15.5228475 20,10 C20,7.3478351 18.9464316,4.80429597 17.0710678,2.92893219 C15.195704,1.0535684 12.6521649,0 10,0 Z",
    id: "Path",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,10.8333333 L5,10.8333333 C4.53976271,10.8333333 4.16666667,10.4602373 4.16666667,10 C4.16666667,9.53976271 4.53976271,9.16666667 5,9.16666667 L15,9.16666667 C15.4602373,9.16666667 15.8333333,9.53976271 15.8333333,10 C15.8333333,10.4602373 15.4602373,10.8333333 15,10.8333333 Z",
    id: "Path",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartControlZoomOut);
export default __webpack_public_path__ + "static/media/chartControl_ZoomOut.e7b2b0e5aaf86564cf9fd502b4d6d2b0.svg";
export { ForwardRef as ReactComponent };